{
  "nl": {
    "todo_list": {
      "actions": {
        "add": "Takenlijst toevoegen",
        "cancel": "Cancel",
        "delete_todo_list": "Verwijder takenlijst",
        "edit": "Bewerken",
        "new": "Takenlijst",
        "save": "Opslaan",
        "title": "Takenlijst titel"
      },
      "attributes": {
        "name": "Titel"
      },
      "labels": {
        "assignToLevel": "Toewijzen aan level",
        "createdAt": "Gemaakt op",
        "filter_employee": "Verantwoordelijke",
        "newTodoList": "Nieuwe takenlijst",
        "sort": {
          "created_at_asc": "Oudste eerst",
          "created_at_desc": "Nieuwste eerst",
          "name_lower_asc": "Titel A -> Z",
          "name_lower_desc": "Titel Z -> A"
        }
      },
      "phase_out": {
        "body": "Taken (oud) stopt eind 2026. Zet taken die je nog nodig hebt vóór 1 januari 2027 over naar Taken. Tot dan kun je bestaande taken blijven gebruiken en afvinken.",
        "title": "Taken (oud) verdwijnt"
      },
      "placeholders": {
        "empty": "Geen takenlijsten hier"
      },
      "toasts": {
        "create": "Takenlijst aangemaakt",
        "delete": "Takenlijst verwijderd",
        "update": "Takenlijst gewijzigd"
      },
      "validation": {
        "needTitle": "Titel vereist"
      }
    }
  }
}
